<template>
  <div>

    <archived-trashed-status
      :form="form"
      :processing="processing"
      :title="$route.meta.title"
    />

    <div class="row mb-3">
      <div class="col-sm-12 col-md-3">
        <template v-if="form.name">
          <h2 id="title" class="m-0">
            {{ form.name }}
          </h2>
          <p>
          <router-link :to="{name: 'settings.index'}">Settings</router-link> /
          <router-link :to="{name: $route.meta.base_url+'.index'}">{{ $route.meta.title }}s</router-link> / Edit {{ $route.meta.title }}
        </p>

        </template>

        <template v-if="form.map_url && !form.virtual">
          <a
            :href="form.map_url"
            target="_blank"
          >{{ form.full_address }}</a>
          <merge-tag :merge_tag="'[LocationFullAddress]'" />
        </template>
      </div><!--Col-->

      <div class="col-sm-12 col-md-3">
          <template v-if="portal && portal.uuid">
            <a :href="'https://'+portal.link+'.'+portal.domain+'/l/'+form.uuid" class="btn btn-outline-primary" target="_blank"><i class="fa fa-link"></i> Open Portal Link</a>
          </template>
      </div><!--Col-->

      <div class="col-sm-12 col-md-3">
        <template v-if="form.full_address && !form.virtual">
          <map-links :address="form.full_address" />
        </template>
      </div><!--Col-->

      <div class="col-sm-12 col-md-3 text-end">

          <div class="btn-group">

            <template v-if="form.uuid">
            <button type="button" class="btn btn-secondary" @click="downloadPDF()" :disabled="processing || downloading"><i class="fa fa-file-pdf"></i> PDF </button>
            </template>

            <button
              type="button"
              class="btn btn-outline-primary dropdown-toggle radius-right-0"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Tools
            </button>
            <div class="dropdown-menu">
              <a
                  v-if="!form.archived_at && !form.deleted_at"
                  class="dropdown-item"
                  @click="archiveRecord(form)"
              >Archive</a>
              <a
                  v-if="form.archived_at || form.deleted_at"
                  class="dropdown-item"
                  @click="restoreRecord(form)"
              >Restore</a>
              <a
                  v-if="!form.deleted_at && !form.archived_at"
                  class="dropdown-item"
                  @click="trashRecord(form)"
              >Trash</a>
            </div>
            <button
              type="submit"
              class="btn btn-success"
              :disabled="processing"
              @click="postForm()"
            >
             Save
            </button>
        <router-link
          :to="{ name: $route.meta.base_url+'.index' }"
          class="btn btn-danger"
        >
          Close
        </router-link>
        </div><!--Group-->
      </div><!--Col-->
    </div><!--Row-->
    <div class="row">
      <div class="col-sm-12 col-md-3">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="postForm()">

              <div class="form-group">
                <label for="name">Name <merge-tag :merge_tag="'[LocationName]'" /></label>
                <input
                  id="name"
                  v-model="form.name"
                  type="text"
                  class="form-control"
                  required
                >
                <p class="text-muted small">The public-facing location name</p>
              </div>

              <div class="form-group">
                <label for="location_reference">Location Reference</label>
                <input
                  id="location_reference"
                  v-model="form.location_reference"
                  type="text"
                  class="form-control"
                  :disabled="!superAdmin"
                >
                <p class="text-muted small">Internal reference for this location</p>
              </div>

              <div class="form-group">
                <label for="description">Description <merge-tag :merge_tag="'[LocationDescription]'" /></label>
                <textarea
                  id="description"
                  v-model="form.description"
                  class="form-control"
                  rows="3"
                  maxlength="255"
                />
                <span
                  class="text-muted small"
                  :style="descriptionLength === 255 ? 'color: #dc3545!important' : ''"
                >{{ descriptionLength }} of 255</span>
              </div>

                  <div class="form-group">
                    <label for="address">Address <merge-tag :merge_tag="'[LocationAddress]'" /></label>
                    <input
                      id="address"
                      v-model="form.address"
                      type="text"
                      class="form-control"
                      autocomplete="address-line1"
                      @focus="initAutoFill"
                    >
                  </div>

              <template v-if="!form.virtual">

                  <div class="form-group">
                    <label for="address_2">Address 2 <merge-tag :merge_tag="'[LocationAddress2]'" /></label>
                    <input
                      id="address_2"
                      v-model="form.address_2"
                      type="text"
                      class="form-control"
                      >
                  </div>


                  <div class="form-group">
                    <label for="city">City <merge-tag :merge_tag="'[LocationCity]'" /></label>
                    <input
                      id="city"
                      v-model="form.city"
                      type="text"
                      class="form-control"
                    >
                  </div>

                  <div class="form-group">
                    <label for="state">State <merge-tag :merge_tag="'[LocationState]'" /></label>
                    <select
                      id="state"
                      v-model="form.state"
                      class="form-control"
                      :disabled="processing"
                    >
                      <option value="" />
                      <option
                        v-for="state in states"
                        :value="state.key"
                      >
                        {{ state.label }}
                      </option>
                    </select>
                  </div>

                  <div class="form-group" v-if="form.state">
                    <label for="county">County <merge-tag :merge_tag="'[LocationCounty]'" /></label>
                    <select
                      id="county"
                      v-model="form.county"
                      class="form-control"
                      :disabled="processing"
                    >
                      <option value="" />
                      <template v-for="county in counties">
                        <template v-if="county.state == form.state">
                        <option
                          :value="county.county"
                        >
                          {{ county.county }}
                          </option>
                        </template>
                      </template>
                    </select>
                  </div>
   
                  <div class="form-group">
                    <label for="zip">Zip <merge-tag :merge_tag="'[LocationZip]'" /></label>
                    <input
                      id="zip"
                      v-model="form.zip"
                      type="text"
                      class="form-control"
                    >
                  </div>

                <div class="form-group">
                  <label for="locales">Agency</label>
                  <input id="locales" type="text" class="form-control" v-model="form.locales">
                  <p class="text-muted small">The agency or jurisdiction this location belongs to</p>
                </div>

                <div class="form-group">
                  <label for="latitude">Latitude <merge-tag :merge_tag="'[LocationLat]'" /></label>
                  <input
                      id="latitude"
                      v-model="form.lat"
                      type="text"
                      class="form-control"
                  >
                </div>

                <template v-if="form.lat">
                  <button type="button" class="btn btn-outline-secondary btn-sm mb-3" @click="copyToClipboard(form.lat)" :disabled="processing"><i class="fa fa-copy"></i> Copy</button>
                </template>

                <div class="form-group">
                  <label for="longitude">Longitude <merge-tag :merge_tag="'[LocationLng]'" /></label>
                  <input
                      id="longitude"
                      v-model="form.lng"
                      type="text"
                      class="form-control"
                  >
                </div>

                <template v-if="form.lng">
                  <button type="button" class="btn btn-outline-secondary btn-sm mb-3" @click="copyToClipboard(form.lng)" :disabled="processing"><i class="fa fa-copy"></i> Copy</button>
                </template>

              </template>

              <div class="form-group">
                <label for="map_url"><template v-if="form.virtual">Virtual</template> <template v-else>Location</template> Link <merge-tag :merge_tag="'[LocationLink]'" /></label>
                <input
                    id="map_url"
                    v-model="form.map_url"
                    type="text"
                    class="form-control"
                >
              </div>

              <template v-if="form.virtual">

                <div class="form-group">
                <label for="passcode">Virtual Passcode <merge-tag :merge_tag="'[LocationPasscode]'" /></label>
                <input
                    id="passcode"
                    v-model="form.passcode"
                    type="text"
                    class="form-control"
                >
                </div>
              </template>

                <div class="form-group">
                  <label for="phone">Phone <merge-tag :merge_tag="'[LocationPhone]'" /></label>
                  <input
                    id="phone"
                    v-model="form.phone"
                    type="tel"
                    class="form-control"
                  >
                </div>

                <div class="form-group">
                  <label for="email">Email <merge-tag :merge_tag="'[LocationEmail]'" /></label>
                  <input
                    id="email"
                    v-model="form.email"
                    type="email"
                    class="form-control"
                  >
                </div>

                <div class="form-group">
                  <label for="website">Website <merge-tag :merge_tag="'[LocationWebsite]'" /></label>
                  <input
                    id="website"
                    v-model="form.website"
                    type="text"
                    class="form-control"
                  >
                </div>

              <label for="instructions" class="text-muted">Instructions 
                <merge-tag :merge_tag="'[LocationInstructions]'" />
              </label>

              <template v-if="form.uuid">
                    <div class="form-group">
                    <editor 
                    id="instructions"
                    ref="instructions"
                    :options="$root.editorOptions"
                    initialEditType="wysiwyg"
                    :initialValue="setEditorValue('instructions')"
                    @change="changeEditor('instructions')"
                  />
                  </div>
              </template>

              <div class="form-group">
                <label for="judge">Default Judge</label>
                <select id="judge" class="form-control" v-model="form.judge" :disabled="processing">
                  <option value=""></option>
                  <template v-for="(judge, judge_index) in judges">
                    <option :value="judge.name">{{ judge.name }}</option>
                  </template>
                </select>
                <small class="text-muted">Can be overridden by Event.</small>
              </div>

              <div class="form-group">
                <label for="business_hours">Business Hours</label>
                <input id="business_hours" type="text" class="form-control" v-model="form.business_hours">
              </div>

              <div class="form-group">
                <label for="business_days">Business Days</label>
                <input id="business_days" type="text" class="form-control" v-model="form.business_days">
              </div>

              <div class="form-group">
                <label for="timezone">Time Zone</label>
                <select id="timezone" class="form-control" v-model="form.timezone" :disabled="processing">
                  <option value=""></option>
                  <template v-for="(timezone, timezone_index) in timezones">
                    <option :value="timezone.key">{{ timezone.label }}</option>
                  </template>
                </select>
                <small class="form-text">Leave blank to use the <a href="/settings?tab=general">Time Zone configured in General Settings</a>.</small>
              </div>


                  <div class="form-check">
                    <input
                        id="virtual"
                        v-model="form.virtual"
                        type="checkbox"
                        class="form-check-input"
                    >
                    <label
                        class="form-check-label"
                        for="virtual"
                    > Virtual Location</label>
                  </div>

                  <div class="form-check">
                    <input
                      id="portal"
                      v-model="form.portal"
                      type="checkbox"
                      class="form-check-input"
                    >
                    <label
                      class="form-check-label"
                      for="portal"
                    > Enable on Portals</label>
                  </div>
               
                  <div class="form-check">
                    <input
                      id="default"
                      v-model="form.default"
                      type="checkbox"
                      class="form-check-input"
                    >
                    <label
                      class="form-check-label"
                      for="default"
                    > Default Location</label>
                  </div>

                  <div class="form-check">
                    <input
                      id="disable_messages"
                      v-model="form.disable_messages"
                      type="checkbox"
                      class="form-check-input"
                    >
                    <label
                      class="form-check-label"
                      for="disable_messages"
                    > Auto-Disable Messages</label>
                  </div>
        
                  <button type="submit" class="btn btn-success" :disabled="processing">Save</button>
              
            </form>
          </div><!--Body-->
        </div><!--Card-->

        <template v-if="form && form.uuid">
          <audit-logs class="mt-3" :form="form"></audit-logs>
        </template>

      </div><!--Col-->

      <div class="col-sm-12 col-md-9">

        <template v-if="form.virtual && form.map_url">

          <div class="card">
            <div class="card-body">
              <p class="card-title">Virtual Location</p>

              <template v-if="platform">
                <p id="platform_name">Platform {{ platform }}</p>
              </template>


                <template v-if="platform && platform != 'unknown'">

                <a :href="setWebLink(form.map_url)" target="_blank">
                    <img :src="'https://assets.ecourtdate.com/images/virtual-logos/'+platform+'.svg'" width="150" :alt="platform">
                </a>

                  <br>

                <div class="btn-group mt-3">
                <a id="browser_link" :href="setWebLink(form.map_url)" class="btn btn-primary" target="_blank">Open in Browser</a>
                <template v-if="setAppLink(form.map_url)">
                 <a id="desktop_link" :href="setAppLink(form.map_url)" class="btn btn-primary text-capitalize" target="_blank">Open in Desktop</a>
                </template>
                </div>

                </template>


            </div>
          </div>

        </template>

        <div
          id="map"
          class="map-lg"
        />

        <div class="row my-3">
          <div class="col-sm-12 col-md-3">
            <div class="card">
              <div class="card-body">

                <p class="card-title">
                    <template v-if="roomForm.uuid">Edit</template>
                    <template v-else>Create</template>
                  Room
                </p>

                <form @submit.prevent="postRoomForm()">
                  <div class="form-group">
                    <label for="room_name">Name</label>
                    <input
                      id="room_name"
                      v-model="roomForm.name"
                      type="text"
                      class="form-control"
                      required
                    >
                  </div>

                  <template v-if="roomForm.uuid">

                  <div class="form-group">
                    <label for="room_reference">Reference</label>
                    <input
                      id="room_reference"
                      v-model="roomForm.reference"
                      type="text"
                      class="form-control"
                    >
                  </div>

                  <div class="form-group">
                    <label for="floor">Floor</label>
                    <input
                      id="floor"
                      v-model="roomForm.floor"
                      type="number"
                      class="form-control"
                    >
                  </div>

                  <div class="form-group">
                    <label for="sort">Sort</label>
                    <input
                      id="sort"
                      v-model="roomForm.sort"
                      type="number"
                      class="form-control"
                    >
                  </div>

                  <div class="form-group">
                    <label for="room_description">Description</label>
                    <textarea
                      id="room_description"
                      v-model="roomForm.description"
                      class="form-control"
                      rows="3"
                    />
                  </div>

                  <div class="form-check">
                    <input
                      id="room_ada"
                      v-model="roomForm.ada"
                      type="checkbox"
                      class="form-check-input"
                    >
                    <label
                      class="form-check-label"
                      for="room_ada"
                    >ADA</label>
                    <p class="text-muted small">If the room is ADA compliant</p>
                  </div>

                  </template>

                  <button type="submit" class="btn btn-success" :disabled="processing">
                    <template v-if="roomForm.uuid">Save</template>
                    <template v-else>Create</template>
                  </button>

                </form>

                <template v-if="roomForm.uuid">
                  <button type="button" class="btn btn-danger btn-sm mt-3" @click="trashRoomForm()" :disabled="processing">Trash</button>
                </template>


              </div><!--Body-->
            </div><!--Card-->
          </div><!--Col-->

          <div class="col-sm-12 col-md-9">

        <div class="card">
            <div class="card-body">
              <p class="card-title">{{ rooms.length }} Rooms</p>

              <template v-if="rooms.length">
                <div class="rooms-grid">
                  <!-- Header row -->
                  <div class="rooms-grid-header">
                    <div class="col-actions">Actions</div>
                    <div class="col-name">Name</div>
                    <div class="col-reference">Reference</div>
                    <div class="col-floor">Floor</div>
                    <div class="col-sort">Sort</div>
                    <div class="col-ada text-center">ADA</div>
                    <div class="col-description">Description</div>
                  </div>
                  
                  <!-- Draggable content -->
                  <draggable
                    v-model="rooms"
                    group="rooms"
                    @start="drag=true"
                    @end="drag=dragRoomEnd($event)"
                  >
                    <div 
                      v-for="room in rooms" 
                      :key="room.uuid" 
                      class="rooms-grid-row"
                    >
                      <div class="col-actions">
                        <div class="btn-group">
                          <template v-if="!roomForm.uuid || roomForm.uuid != room.uuid">
                            <button class="btn btn-sm btn-outline-primary" @click="getRoom(room)" :disabled="processing">
                              <i class="fa fa-edit"></i>
                            </button>
                          </template>
                          <template v-if="roomForm.uuid && roomForm.uuid == room.uuid">
                            <button class="btn btn-sm btn-outline-danger" @click="getRoom(room)" :disabled="processing">
                              <i class="fa fa-times"></i>
                            </button>
                          </template>
                          <button class="btn btn-sm btn-outline-secondary" type="button">
                            <i class="fa fa-arrows-alt"></i>
                          </button>
                        </div>
                      </div>
                      <div class="col-name">{{ room.name }}</div>
                      <div class="col-reference">{{ room.reference || '' }}</div>
                      <div class="col-floor">{{ room.floor || '' }}</div>
                      <div class="col-sort">{{ room.sort || '' }}</div>
                      <div class="col-ada text-center">
                        <i v-if="room.ada" class="fa fa-wheelchair text-primary" title="ADA Accessible"></i>
                        <i v-else class="fa fa-ban text-danger" style="position: relative;" title="Not ADA Accessible">
                          <i class="fa fa-wheelchair text-muted" style="position: absolute; font-size: 0.8em; left: 50%; top: 50%; transform: translate(-50%, -50%);"></i>
                        </i>
                      </div>
                      <div class="col-description">{{ room.description || '' }}</div>
                    </div>
                  </draggable>
                </div>
              </template>
              <div v-else class="alert alert-info">
                No rooms have been added to this location yet.
              </div>
            </div><!--Body-->
          </div><!--Card-->
          </div><!--Col-->

        </div><!--Row--->

      </div><!--Col-->

    </div><!--Row-->
  </div>
</template>

<script>
import { autofill } from '@mapbox/search-js-web';
import draggable from 'vuedraggable';
import queries from '../mixins/queries';

export default {

  mixins: [ queries ],

  components: {
    draggable
  },

  data () {
    return {
      processing: false,
      downloading: false,
      form: {},
      states: [],
      timezones: [],
      platform: null,
      portal: {},
      judges: [],
      rooms: [],
      counties: [],
      roomForm: {},
      autofill: null,
      autofillCallback: null,
      drag: false,
      mapStyle: 'default',
      mapLayers: {},
      mapStyles: {
        default: {
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          options: {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            name: 'Default'
          }
        },
        satellite: {
          url: 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
          options: {
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            attribution: '© Google Maps',
            name: 'Satellite'
          }
        },
        dark: {
          url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
          options: {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            name: 'Dark'
          }
        },
        topo: {
          url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
          options: {
            attribution: 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a>',
            name: 'Topographic'
          }
        },
        street: {
          url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
          options: {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            name: 'Light'
          }
        }
      }
    }
  },
  computed: {

    descriptionLength () {
      return this.form.description && this.form.description.length > 0 ? this.form.description.length : 0;
    },

    superAdmin () {
      return this?.$root?.current_user?.super_admin;
    }
  
  },

  mounted () {
    this.initAutoFill();
  },
  
  created () {

    this.resetForm();
    this.resetRoomForm();
    this.getRecord();
    this.getStates();
    this.getTimezones();
    this.getJudges();
    this.getCounties();
  },

  watch: {
    // Re-initialize autofill when the form changes
    'form.address': function() {
      this.initAutoFill();
    }
  },

  methods: {

    resetForm() {
        this.form = {
            name: null,
            address: null,
            address2: null,
            city: null,
            state: null,
            zip: null,
            country: null,
            lat: null,
            lng: null,
            instructions: null,
            judge: null,
            business_hours: null,
            business_days: null,
            timezone: null,
            map_url: null,
            passcode: null,
            virtual: false,
            portal: false,
            default: false,
            disable_messages: false
        }
    },

    initAutoFill() {
      // Wait for the DOM to be ready
      this.$nextTick(() => {
        try {
          // Clean up any previous instance
          if (this.autofill) {
            try {
              // Try to clean up the old instance
              this.autofill = null;
            } catch (e) {
              // Ignore cleanup errors
            }
          }
          
          // Create a fresh autofill instance
          this.autofill = new autofill({
            accessToken: this.$root.mapbox_token,
            options: {
              language: 'en',
              country: this.settings?.country || 'us'
            }
          });
          
          const self = this;
          
          // Simple retrieve event handler
          this.autofill.addEventListener('retrieve', function(event) {
            if (!event.detail?.features?.[0]) return;
            
            const feature = event.detail.features[0];
            console.log('Address feature selected:', feature);
            
            // Update name if blank
            if (feature.text_en && !self.form.name) {
              self.form.name = feature.text_en;
            }
            
            // Update coordinates
            if (feature.geometry?.coordinates) {
              self.form.lat = feature.geometry.coordinates[1];
              self.form.lng = feature.geometry.coordinates[0];
              self.initMap();
              self.$eventBus.$emit('show-alert', {
                text: 'Address coordinates updated',
                type: 'success'
              });
            }
            
            // Update address fields from properties
            const props = feature.properties;
            if (props) {
              if (props.district) self.form.county = props.district;
              if (props.country_code) self.form.country = props.country_code;
              if (props.address_line2) self.form.address_2 = props.address_line2;
              if (props.city) self.form.city = props.city;
              if (props.address_level1) self.form.state = props.address_level1;
              if (props.postcode) self.form.zip = props.postcode;
              
              // Make sure the address field is updated with the selection
              if (props.address_line1) {
                self.form.address = props.address_line1;
              }
            }
            
            // Save form after selection
            self.postForm();
          });
        } catch (err) {
          console.error('Error initializing autofill:', err);
        }
      });
    },
    
    autoFill() {
      // This is just a proxy to the init method now
      this.initAutoFill();
    },

    getRecord () {
      this.processing = true;
      this.$http.get('/'+this.$route.meta.base_url+'/'+this.$route.params.id)
      .then((response) => {
        if (response && response.data) {
          this.form = response.data;
          this.processing = false;

          this.getGeocodes();

          this.getPortal();

          if(this.form.name) {
            this.setTitle();
          }

          this.getRooms();

          if(this.form.map_url) {
            this.platform = this.setVirtualPlatform(this.form.map_url);
          }
          
          // Reinitialize autofill with fresh instance
          setTimeout(() => {
            this.initAutoFill();
          }, 300);
        }
      })
    },

    getPortal() {
        this.$http.get('/portals?sort=default&sortDirection=desc&fields=uuid,link,domain,name&limit=1')
            .then(response => {
              if(response && response.data) {

                if(response.data[0]) {
                  this.portal = response.data[0];
                }
              }
            })
    },
    
    getGeocodes() {

      if(this.form.lat && this.form.lng) {
        this.initMap();
        return;
      }

      if(this.form.virtual) {
        return;
      }

      var address = null;

      var fields = ['address', 'address_2', 'city', 'state', 'zip'];

      for (var field in fields) {
        if(this.form[fields[field]]) {
          address += this.form[fields[field]] + ' ';
        }
      }

            this.$http.get('/geocode?address='+address)
            .then(response => {
                if(response && response.data) {

                    if(response.data[0] && response.data[0]['geometry']) {
                        if(response.data[0]['geometry']['location']) {
                            this.form.lat = response.data[0]['geometry']['location']['lat'];
                            this.form.lng = response.data[0]['geometry']['location']['lng'];
                            this.initMap();
                        }
                    }

                }
            })
    },

    setTitle() {
      document.title = this.form.name + ' | Edit '+ this.$route.meta.title;
    },

    postForm () {
      this.processing = true;

      this.getGeocodes();

      this.$http.patch('/'+this.$route.meta.base_url+'/'+this.form.uuid, this.form)
      .then(response => {
        if (response && response.status) {

          if(response.data.updated_at) {
            this.$eventBus.$emit('show-alert', {
              text: this.$route.meta.title + ' updated'
            });
            this.form.updated_at = new Date().toISOString();
          }

          this.processing = false;

          if(this.form.map_url) {
            this.platform = this.setVirtualPlatform(this.form.map_url);
          }

          this.setMarker();
          
        }
      })
    },

    getRooms() {
      if(!this.form.uuid) {
        return;
      }

      this.$http.get('/rooms?location='+this.form.uuid+'&limit=1000&sort=sort&sortOrder=asc')
          .then(response => {
            if(response && response.data) {
              this.rooms = response.data;
              
              // Check for missing sort values and assign based on indices
              let needsSort = false;
              this.rooms.forEach((room, index) => {
                if (room.sort === null || room.sort === undefined) {
                  room.sort = index;
                  needsSort = true;
                }
              });
              
              // Only resort if there were missing sort values
              if (needsSort) {
                this.resortRooms();
              }
            }
          })
    },

    resetRoomForm() {
      this.roomForm = {
        name: null,
        reference: null
      }
    },

    getRoom(room) {
      if(!room.uuid) {
        return;
      }

      if(this.roomForm.uuid == room.uuid) {
        this.resetRoomForm();
        return;
      }

      this.resetRoomForm();

      this.processing = true;

      this.$http.get('/rooms/'+room.uuid)
          .then(response => {
            if(response && response.data) {
              this.roomForm = response.data;
              this.processing = false;
            }
          })
    },

    postRoomForm() {

      if(this.roomForm.uuid) {
        this.updateRoomForm();
        return;
      }

      this.processing = true;

      this.roomForm.location = this.form.uuid;

      this.$http.post('/rooms', this.roomForm)
          .then(response => {
            if(response && response.data) {

              if(!this.rooms) {
                this.rooms = [];
              }

              this.rooms.unshift(response.data);
              this.resetRoomForm();
              this.processing = false;
            }
          })
    },

    updateRoomForm() {
      this.processing = true;

      this.$http.patch('/rooms/'+this.roomForm.uuid, this.roomForm)
          .then(response => {
            if(response && response.status === 200) {
              this.processing = false;

              this.$eventBus.$emit('show-alert', {
                text: 'Room updated'
              });

              this.rooms = this.rooms.map(room => {
                if(room.uuid === this.roomForm.uuid) {
                  return this.roomForm;
                }
                return room;
              });

              this.resortRooms();
            }
          })
    },

    trashRoomForm() {

      if(!this.roomForm.uuid) {
        return;
      }

      this.processing = true;

      this.$http.delete('/rooms/'+this.roomForm.uuid)
          .then(response => {
            if(response && response.status) {

              if(response.status === 204) {
                this.$eventBus.$emit('show-alert', {
                  text: 'Room trashed',
                  type: 'danger'
                });
                this.rooms = this.rooms.filter(room => room.uuid !== this.roomForm.uuid);
                this.resetRoomForm();
              }

              this.processing = false;
            }
          })
    },


    setVirtualPlatform(link) {

      let platform = this.settings['virtual_platform'] || 'zoom';

      if(platform) {
        return platform.toLowerCase();
      }

      if (/zoom\.us\/j\//i.test(link) || /zoom\.us\/w\//i.test(link)) {
        return 'zoom';
      } else if (/teams\.microsoft\.com/i.test(link)) {
        return 'teams';
      } else if (/webex\.com\/meet\//i.test(link) || /webex\.com\/join\//i.test(link)) {
        return 'webex';
      }
      else {
        return 'unknown';
      }
    },

    setAppLink(link) {
      switch (this.platform.toLowerCase()) {
        case 'zoom':
          if (link.startsWith("https://") || link.startsWith("http://")) {
            return;
          }
          return `zoomus://zoom.us/wc/${link}/join`;

        case 'teams':
          if (link.startsWith("https://") || link.startsWith("http://")) {
            return;
          }
          return `msteams://teams.microsoft.com/l/meetup-join/${link}`;
      }
    },

    setWebLink(link) {
      switch (this.platform.toLowerCase()) {
        case 'zoom':
          if (link.startsWith("https://") || link.startsWith("http://")) {
            return link;
          }

          var url = `https://zoom.us/wc/${link}/join`;

          if(this.form.passcode) {
            url += `?pwd=${this.form.passcode}`;
          }

          return url;

        case 'teams':
          if (link.startsWith("https://") || link.startsWith("http://")) {
            return link;
          }
          return `https://teams.microsoft.com/l/meetup-join/${link}`;

        case 'webex':
          if (link.startsWith("https://") || link.startsWith("http://")) {
            return link;
          }
          return `https://meetings.webex.com/webex/?meetingNumber=${link}`;

      }

      return link;

    },

    getJudges() {
      this.$http.get('/judges?slim=true&fields=uuid,name&limit=1000&sort=name&sortOrder=asc')
          .then(response => {
            if(response && response.data) {
              this.judges = response.data;
            }
          })
    },

    initMap() {
      if(this.map) {
        this.map.remove();
      }

      console.log(this.form.lat, this.form.lng);

      this.map = window.L.map("map").setView(this.$root.coordinates, 4);

      // Create base layers for the layer control
      this.mapLayers = {};
      
      // Create each layer from our map styles
      Object.keys(this.mapStyles).forEach(key => {
        const style = this.mapStyles[key];
        const options = { ...style.options };
        delete options.name; // Remove name from the tile layer options
        
        this.mapLayers[style.options.name] = window.L.tileLayer(style.url, options);
      });
      
      // Add the default layer to the map
      this.mapLayers[this.mapStyles.default.options.name].addTo(this.map);
      
      // Add layer control to the map
      window.L.control.layers(this.mapLayers, {}, {
        position: 'topright',
        collapsed: false
      }).addTo(this.map);

      // Add custom info control
      const infoControl = window.L.control({ position: 'bottomleft' });
      infoControl.onAdd = function() {
        const div = window.L.DomUtil.create('div', 'info-control');
        div.innerHTML = '<div class="p-2 bg-white rounded border shadow-sm"><i class="fa fa-info-circle text-primary"></i> Click anywhere on the map or move the marker to update location coordinates</div>';
        return div;
      };
      infoControl.addTo(this.map);

      // Add click handler to map
      this.map.on('click', (e) => {
        const newLat = e.latlng.lat.toFixed(6);
        const newLng = e.latlng.lng.toFixed(6);
        
        if (confirm(`Update location coordinates?\n\nNew position:\nLatitude: ${newLat}\nLongitude: ${newLng}`)) {
          this.form.lat = newLat;
          this.form.lng = newLng;
          this.postForm();
          this.setMarker();
          
          this.$eventBus.$emit('show-alert', {
            text: 'Location coordinates updated',
            type: 'success'
          });
        }
      });

      this.setMarker();
    },

    setMarker() {
      if(!this.form.lat || !this.form.lng) {
          return;
      }

      //if map is not initialized, return
      if(!this.map) {
        this.initMap();
        return;
      }

      const courtIcon = window.L.divIcon({
        html: '<i class="fa fa-building-columns text-primary fa-2x"></i>',
        iconSize: [20, 20],
        className: 'map-icon'
      });

      var popup = '<p class="m-0">Address: '+this.form.full_address+'</p>';


        // Create new marker and set up drag event
        this.marker = window.L.marker([this.form.lat, this.form.lng], {icon: courtIcon, draggable: true}).addTo(this.map).bindPopup(popup);
        
        var self = this;
        
        this.marker.on('dragend', function(event) {
          var coords = self.marker.getLatLng();
          self.form.lat = coords.lat;
          self.form.lng = coords.lng;
        });
        
        // Initial zoom to marker position
        this.map.flyTo([this.form.lat, this.form.lng], 14);
    },

    dragRoomEnd(event) {
      //update room sort order using event index
      let room = this.rooms[event.oldIndex];
      
      // Update the sort value locally first to match the new index
      this.rooms[event.newIndex].sort = event.newIndex;
      
      this.$http.patch('/rooms/'+room.uuid, {sort: event.newIndex})
          .then(response => {
            if(response && response.status === 200) {
              this.$eventBus.$emit('show-alert', {
                text: 'Room order updated'
              });
              
              // Update all room sort values to match their current indices
              this.rooms.forEach((room, index) => {
                room.sort = index;
              });
            }
          })
    },

    resortRooms() {
      // First sort by the current sort values
      this.rooms = this.rooms.sort((a, b) => a.sort - b.sort);
      
      // Then update all sort values to match their current indices
      // This ensures consistency between display order and sort values
      this.rooms.forEach((room, index) => {
        room.sort = index;
      });
    },

    changeEditor(field) {
      this.form[field] = this.$refs[field].invoke('getHTML');
    },

    setEditorValue(field) {

      if(!this.form[field]) {
        return;
      }

      return this.form[field];
    },

    getCounties() {
        this.$axios.get('https://assets.ecourtdate.com/js/counties.json')
        .then(response => {
          if(response && response.data) {
            this.counties = response.data;
          }
        })
      },

  }
}
</script>

<style scoped>
.rooms-grid {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  overflow: hidden;
}

.rooms-grid-header {
  display: flex;
  background-color: #f8f9fa;
  font-weight: bold;
  border-bottom: 2px solid #dee2e6;
  padding: 0.75rem;
}

.rooms-grid-row {
  display: flex;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem;
  align-items: center;
  cursor: move;
}

.rooms-grid-row:last-child {
  border-bottom: none;
}

.rooms-grid-row:hover {
  background-color: rgba(0,0,0,.075);
}

.col-actions {
  width: 120px;
  flex-shrink: 0;
}

.col-name {
  flex: 1;
  min-width: 150px;
}

.col-reference {
  width: 100px;
  flex-shrink: 0;
}

.col-description {
  flex: 1;
  min-width: 150px;
}

.col-floor {
  width: 100px;
  flex-shrink: 0;
}

.col-sort {
  width: 100px;
  flex-shrink: 0;
}

.col-ada {
  width: 80px;
  flex-shrink: 0;
}

.rooms-grid-row {
  cursor: move; /* Indicate the entire row is draggable */
}

.info-control {
  font-size: 0.9rem;
  background: none;
  border: none;
}

.info-control div {
  background-color: white;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid rgba(0,0,0,0.2);
  box-shadow: 0 1px 5px rgba(0,0,0,0.2);
  max-width: 350px;
}
</style>
